import  React from 'react'
import Button from 'react-bootstrap/Button'

export interface PrintBackButtonsProps {
    printLabel?: string
    backLabel?: string
    onBack?: { (): any }
    onPrint?: { (e: React.MouseEvent): any }
}

export const PrintBackButtons: React.FC<PrintBackButtonsProps> = (props: PrintBackButtonsProps) => (
  <div className="clearfix mt-3 d-print-none">
    <Button className="emdg-btn float-right" onClick={props.onPrint} style={{ display: props.onPrint ? '' : 'none' }}>
      {props.printLabel || 'Print'}
    </Button>
    <Button  className="emdg-btn emdg-btn--secondary float-left" onClick={props.onBack} style={{ display: props.onBack ? '' : 'none' }}>
      {props.backLabel || 'Back'}
    </Button>
  </div>
)
